import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IonicModule } from '@ionic/angular';
import { provideFormlyConfig } from '@ngx-formly/core';

import { ButtonFormWrapperUiComponent } from './button-form-wrapper-ui/button-form-wrapper-ui.component';

@NgModule({
  imports: [CommonModule, IonicModule],
  declarations: [ButtonFormWrapperUiComponent],
  exports: [ButtonFormWrapperUiComponent],
  providers: [
    provideFormlyConfig({
      wrappers: [
        {
          name: 'button',
          component: ButtonFormWrapperUiComponent,
        },
      ],
    }),
  ],
})
export class SharedFormWrapperUiButtonModule {}
